import {Component} from '@angular/core';
import {ChoiceBaseComponent} from '@shared/form/choice/choice-base.component';
import {LucideAngularModule} from 'lucide-angular';
import {FieldContainerComponent} from '@shared/form/field-container/field-container.component';
import {ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'app-choice-select-field',
  imports: [
    LucideAngularModule,
    FieldContainerComponent,
    ReactiveFormsModule
  ],
  templateUrl: './choice-select-field.component.html'
})
export class ChoiceSelectFieldComponent<valueT> extends ChoiceBaseComponent<valueT> {
}
